export default __webpack_public_path__ + "static/media/tabs.58646e2c.png";